<mat-form-field class="conditional__full-width eiq-survey-textarea" appearance="outline">
  <textarea
    matInput
    [formControl]="surveyConditionalsService.conditionForm$().get('valueToMatch') | toFormControl"
    placeholder="Type the value to match on the condition"
    aria-label="Type the value to match on the condition"
    (keydown.enter)="$event.preventDefault()"
    (keyup.enter)="onSelectValueToMatch()"
  ></textarea>

  <mat-hint align="end">Use ; to separate different words</mat-hint>
</mat-form-field>
